import DataTable from "../../DataTables/DataTable";
import PropTypes from "prop-types";
import StatusBadge from "../../assests/StatusBadge";
import { formatToDate } from "../../configs/formatToDate";
import { formatTime } from "../../configs/formatTime";

function BookingsTable(props) {
  const { data, isLoading } = props;
  const columns = [
    {
      title: "BOOKING ID",
      dataIndex: "booking_id",
    },
    {
      title: "TYPE",
      dataIndex: "type",
    },
    {
      title: "PATIENT NAME",
      dataIndex: "patientname",
      render: (_item, record) => (
        <div>{record?.user_details?.name ?? record?.user?.first_name}</div>
      ),
    },
    {
      title: "ASSIGNED DOCTOR",
      dataIndex: "assingned",
      render: (_item, record) =>
        record?.doctor?.name ? (
          <div className="text-start">Dr.{record?.doctor?.name}</div>
        ) : (
          <div>N/A</div>
        ),
    },

    {
      title: "TIME SLOT",
      dataIndex: "timeSlot",
      render: (_item, record) => (
        <div>{formatTime(record?.timeSlot) ?? "unassigned"}</div>
      ),
    },
    {
      title: <div className="text-center">APPOINTMENT DATE</div>,
      dataIndex: "appointmentDate",
      render: (item) => <div className="text-center">{formatToDate(item)}</div>,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      render: (item) => (
        <div className="d-flex justify-content-center">
          <StatusBadge status={item} />
        </div>
      ),
    },
  ];
  return (
    <div>
      <h5>
        {data?.length} {data.length > 1 ? "bookings" : "booking"} found
      </h5>
      <div className="table-responsive">
        <DataTable data={data} columns={columns} isLoading={isLoading} />
      </div>
    </div>
  );
}

BookingsTable.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default BookingsTable;
